import React from 'react';
import {
  Box,
  Column,
  Row,
  SkeletonLoader,
} from '@chargify/custom-ui-components';
import { useDeviceInfo } from '@chargify/device-provider';

const SubscriptionsManagerLoader = () => {
  const { device } = useDeviceInfo();
  const isOnMobile = device === 'mobile';

  return (
    <div data-testid="subscription-manager-loader">
      <Row rowGap={8}>
        <Column span={12}>
          <Box marginBottom={6}>
            <SkeletonLoader height={28} width={150} />
          </Box>
        </Column>
      </Row>
      <Row rowGap={8}>
        <Column span={24}>
          <Box marginBottom={4}>
            <SkeletonLoader height={isOnMobile ? 40 : 60} />
          </Box>
          <Box marginBottom={4}>
            <SkeletonLoader height={isOnMobile ? 40 : 60} />
          </Box>
          <Box marginBottom={4}>
            <SkeletonLoader height={isOnMobile ? 40 : 60} />
          </Box>
        </Column>
      </Row>
    </div>
  );
};

export default SubscriptionsManagerLoader;
